/** @jsx jsx */
import { jsx } from 'theme-ui'
import PropTypes from 'prop-types'
import * as contentful from 'contentful'
import ImageText from './ImageText'
import CustomImage from './CustomImage'
import CustomVideo from './CustomVideo'
import CalendarArticle from './CalendarArticle'
import CustomButton from './CustomButton'
import CustomTable from './CustomTable'
import ScrollToSection from './ScrollToSection'
import ScrollToLink from './ScrollToLink'
import { useState, useEffect } from 'react'
import { token, host } from '../../apollo/contentfulClient'

const CustomEmbed = ({ data }) => {
  //Each time you add a new content type in Contenful to Article, add the contenful_id here as a key and then create a new jsx template for the layout
  const CustomEmbedEnum = {
    imageText: ImageText,
    imageEmbed: CustomImage,
    videoEmbed: CustomVideo,
    richTextButton: CustomButton,
    tableEmbed: CustomTable,
    calendarArticle: CalendarArticle,
    scrollToSection: ScrollToSection,
    scrollToLink: ScrollToLink,
  }

  const [CustomEmbedComponent, setCustomEmbedComponent] = useState(null)

  useEffect(() => {
    const fetchEmbedEntries = async () => {
      const client = contentful.createClient({
        space: process.env.GATSBY_CONTENTFUL_SPACE_ID,
        environment: process.env.GATSBY_CONTENTFUL_ENVIRONMENT,
        accessToken: token,
        host: host,
      })
      const entries = await client.getEntries({
        'sys.id': data.target?.sys?.id,
        include: 10,
      })
      const entry = entries.items[0]
      if (entry) {
        const EmbedComponent =
          CustomEmbedEnum[entry.sys.contentType.sys.id] || null
        EmbedComponent
          ? setCustomEmbedComponent(
              <EmbedComponent data={entry} id={entry.sys.id} />
            )
          : setCustomEmbedComponent(EmbedComponent)
      }
    }
    fetchEmbedEntries()
  }, [data])
  return <div style={{ width: '100%' }}>{CustomEmbedComponent}</div>
}

CustomEmbed.propTypes = {
  data: PropTypes.object.isRequired,
}

export default CustomEmbed
